import { cloneDeep } from 'lodash';
import { priceCart, MAX_CART_ITEM, implodeCart, explodeCart }  from '../shared/cart.js';
import { getCookie } from '../shared/cookie';
import { firePromoMessage, clearPromoMessage } from './promo_message';
const SET_COMPUTED_CART = 'SET_COMPUTED_CART';

const initialState = {
  credits_applied   : [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  promo_items       : [],
  credits_available : 0,
  credits_used      : 0,
  items             : [],
  shipping          : 0.00,
  subtotal          : 0.00,
  tax               : 0.00,
  total             : 0.00,
  promo             : null
};

export default function reducer(state = cloneDeep(initialState), action) {
  switch (action.type) {
    case SET_COMPUTED_CART:
      return {...action.payload};
    default:
      return state;
  }
}

export function setComputedCart( oCustomer = {}, oComputedCart, cart,  isToggle=false ){
  return (dispatch, getState) => {
    oComputedCart.items = explodeCart(oComputedCart.items);
    let newComputedCart = {};
    let aCart         = oCustomer && oCustomer.status === "Active" && !getState().upgradeStatus && oCustomer.cart ? [...oCustomer.cart] : [...cart] || [];
    aCart             = explodeCart(aCart);
    let oCartPrices   = [];
    let aCreditsUsed  = [0,0,0,0];
    let oPromo        = oComputedCart.promo || null;
    let isEnrollment = (!oCustomer.cart || oCustomer.status !== 'Active' || getState().upgradeStatus);

    // If no customer or customer is pending enrollment, use enrollment pricing
    if (isEnrollment) {
      oCartPrices = priceCart(aCart, [], null, getState().store, getState().upgradeStatus );

    } else {
      // Otherwise, use customer pricing and credits
      newComputedCart.credits_available = oCustomer.credit_total;
      newComputedCart.credits_used = 0;

      // calculate prices based on member pricing
      oCartPrices = priceCart( aCart, aCreditsUsed, oCustomer, getState().store, null, oPromo );

      newComputedCart.items = [...aCart.map((oItem, i) => {
        if (oItem) {
          oItem.computed_price = oCartPrices.cart_prices[i];
          oItem.promo = (oPromo && oCartPrices.promo_items[i] ) ? oPromo : null;
        }
        return oItem;
      })];

      if(getState().store.type === "Neglite"){ // credit club
        aCreditsUsed  =  oComputedCart.credits_available ? [ ...oComputedCart.credits_available ] : [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        let fsInCart = aCart[0];

        if (!isToggle){
          aCart.forEach((oItem, i) => { if (oItem) return oItem.credit = false });
          oComputedCart.items.forEach((oItem, i) => { if (oItem) return oItem.credit = false });
        }

        // generate values for aCreditsUsed
        aCreditsUsed = aCart.map((oItem, i) => {
          if (oItem) {
            let oldObj = oComputedCart.items[i];
            if(oCartPrices[i]) oItem = newComputedCart.items[i];
            // If item has a credit applied to it, or it previously had a credit applied and there are credits available,
            // OR it's the Featured Selection (i = 0), has a credit applied, the member has credits available,
            // and the sale price is less than the store's eligibility threshold
            if (isToggle){
              if ( oldObj && oldObj.credit === true && newComputedCart.credits_available > 0 ){
                newComputedCart.credits_available--;
                newComputedCart.credits_used++;
                return 1;
              }
            } else {
              if (oItem.credit === true || ( oldObj && oldObj.credit === true && newComputedCart.credits_available > 0 )
                || (i === 0 && newComputedCart.credits_available > 0 && (oItem.computed_price >= 10 && oItem.computed_price <= getState().store.credit_eligible))
                || (!fsInCart && newComputedCart.credits_available > 0 && (oItem.computed_price >= 10 && oItem.computed_price <= getState().store.credit_eligible))
                || (!getState().store.bundle_pricing && newComputedCart.credits_available > 0 && (oItem.computed_price >= 10 && oItem.computed_price <= getState().store.credit_eligible))
                || (fsInCart && (typeof(getState().promoMessage) === 'object') && newComputedCart.credits_available > 0 && (oItem.computed_price >= 10 && oItem.computed_price <= getState().store.credit_eligible))
                || (fsInCart && getState().promoMessage === false && newComputedCart.credits_available > 0 && (oItem.computed_price >= 10 && oItem.computed_price <= getState().store.credit_eligible))
                 ) {
                newComputedCart.credits_available--;
                newComputedCart.credits_used++;
                return 1;
              }
            }

          }
          return 0;
        });
        // server needs aCreditsUsed to have a length of MAX_CART_ITEM (insert 0 if no item)
        while (aCreditsUsed.length < MAX_CART_ITEM) aCreditsUsed.push(0);

        // give each cart item a boolean key for credit use
        aCart.forEach((oItem, i) => { if (oItem) return oItem.credit = aCreditsUsed[i] === 1 });
      }
    }

    // calculate prices based on member pricing
    oCartPrices = priceCart( aCart, aCreditsUsed, oCustomer, getState().store, getState().upgradeStatus, oPromo );

    newComputedCart.items = [...aCart.map((oItem, i) => {
      if (oItem) {
        oItem.computed_price = oCartPrices.cart_prices[i];
        oItem.promo = (oPromo && oCartPrices.promo_items[i] !== null) ? oPromo : null;
      }
      return oItem;
    })];

    if (!isEnrollment)
      [newComputedCart.items, oCartPrices.promo_items] = implodeCart(newComputedCart.items, oCartPrices.promo_items);

    // set other computed keys
    newComputedCart.credits_applied = aCreditsUsed;
    newComputedCart.promo_items     = oCartPrices.promo_items;
    newComputedCart.subtotal        = oCartPrices.subtotal;
    newComputedCart.shipping        = oCartPrices.shipping;
    newComputedCart.tax             = oCartPrices.tax;
    newComputedCart.total           = oCartPrices.total;
    newComputedCart.promo           = oPromo;

    return dispatch( forceSetComputedCart( newComputedCart ));
  }
}

export function forceSetComputedCart( computedCart ){
  return{
    type: SET_COMPUTED_CART,
    payload: computedCart
  }
}

export function toggleCreditOnCartItem(sProductId, iArrayLoc, creditAlterCount){
  return (dispatch, getState) => {
    let oComputedCart = getState().computedCart;

    let oItem = oComputedCart.items[iArrayLoc];
    let oItemCurCredits = oItem.creditArr.reduce( (a, b) => a + b, 0);
    let currentAvailibleCredits = oComputedCart.credits_available;
    if (oItem && parseInt(oItem.id, 10) === parseInt(sProductId, 10)) {
      let nCreditEligible = getState().store.credit_eligible;

      oItem.creditArr = oItem.creditArr.map( (credit, i) => {
        if(creditAlterCount < oItemCurCredits){
          if( i < creditAlterCount) return true;
          return false;
        } else if( i < creditAlterCount && credit ){
          return true;
        } else if( i < creditAlterCount && !credit && currentAvailibleCredits > 0 ){
          currentAvailibleCredits--;
          return true;
        } else return false;
      });
    }
    return dispatch( setComputedCart( getState().customer, oComputedCart, [], true));
  }
}
/*
export function toggleCreditOnCartItem(sProductId, iArrayLoc) {
  return (dispatch, getState) => {
    let oComputedCart = getState().computedCart;

    let oItem = oComputedCart.items[iArrayLoc];

    if (oItem && parseInt(oItem.id, 10) === parseInt(sProductId, 10)) {
      let nCreditEligible = getState().store.credit_eligible;
      //if(oItem.creditArr && )
      if (oItem.credit === false && oComputedCart.credits_available > 0 && oItem.computed_price <= nCreditEligible) {
        // If item does not have a credit, credits are available, and price is within credit eligible threshold, apply credit
        oItem.credit = true;
      } else if (oItem.credit === true) {
        // If item does have a credit, remove it
        oItem.credit = false;
      }
      // Otherwise do nothing
    }
    return dispatch( setComputedCart( getState().customer, oComputedCart, [], true));
  }
}
*/
export function addPromoToCart(uPromoCode) {
  return (dispatch, getState)=> {
    try {
      let sPromoCode = JSON.stringify(uPromoCode).toUpperCase();
      let aPromos = getState().promos.filter(p=>{ return JSON.stringify(p.promo_code).toUpperCase() === sPromoCode });
      if (aPromos.length === 0) throw { message: 'Invalid or incorrect promo code. Please re-enter.' };

      let oComputedCart = getState().computedCart;
      oComputedCart.promo = aPromos[0];

      return dispatch([
        setComputedCart( getState().customer, oComputedCart, [] ),
        firePromoMessage({
          type: 'success',
          text: 'Your promo code has been successfully applied to eligible titles!'
        })
      ]);

    } catch (error) {
      return dispatch( firePromoMessage({
        type: 'error',
        text: error.message || 'There was an error with your promo code. Please try again.'
      }) );
    }
  }
}

export function removePromoFromCart() {
  return (dispatch, getState)=> {
    let oComputedCart = getState().computedCart;
    oComputedCart.promo = null;

    return dispatch([
      setComputedCart( getState().customer, oComputedCart, []),
      clearPromoMessage()
    ]);
  }
}



// WEBPACK FOOTER //
// ./src/modules/computed_cart.js